import React from 'react';
import PropTypes from 'prop-types';
import cx from '@/utils/cx';
import useStyle from './style';

const Badge = ({
  children,
  className,
  size,
  fab,
  ...rest
}) => {
  const classes = useStyle({ size, fab });
  return (
    <div
      className={cx(classes.badge, className)}
      {...rest}
    >
      {children}
    </div>
  );
};

Badge.propTypes = {
  size: PropTypes.number,
  fab: PropTypes.bool,
};

Badge.defaultProps = {
  size: 16,
  fab: true,
};

export default Badge;
